module.exports = __webpack_public_path__ + "static/media/icon-event__caida-del-comunismo-hover.8bd1f078.svg";